var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-banner"},[(_vm.extraItem.extras('banner.display'))?_c('img',{attrs:{"src":_vm.extraItem.extras('banner.src'),"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }